import Vue from 'vue'
import Confirm from '@/components/Confirm.vue'
const VueComponent = Vue.extend(Confirm)
const vm = new VueComponent().$mount()

let init = false;
const defaultOptions = {
}
const confirm = function(content, title) {
  var options = { content, title }
  Object.assign(vm, defaultOptions, options, {
    type: 'confirm'
  })
  if (!init) {
    document.body.appendChild(vm.$el)
    init = true;
  }
  return vm.confirm(options);
};

export default confirm;
